<template>
    <div class="pp-draw-numbers" :data-test="`results-${sortByDraw ? 'ordered' : 'regular'}`">
        <template v-for="(setNumbers, setIndex) in numbers?.mainGameNumbers" :key="setIndex">
            <template v-for="(drum, drumIndex) in setNumbers.drawingDrums" :key="drumIndex">
                <span
                    v-if="getDrawLabel(setIndex, drumIndex)"
                    class="pp-draw-numbers__draw-title"
                    data-test="row-title"
                >
                    {{ getDrawLabel(setIndex, drumIndex) }}
                </span>
                <ul class="pp-draw-numbers__num-row" :data-test="drumIndex === 0 ? 'row-primary' : 'row-additional'">
                    <li
                        v-for="(num, index) in getNumbers(drum)"
                        class="pp-draw-numbers__number"
                        data-test="number"
                        :key="index"
                    >
                        {{ num }}
                    </li>
                    <li
                        v-if="setNumbers.extraNumber"
                        class="pp-draw-numbers__number pp-draw-numbers__number--extra"
                        data-test="number-extra"
                    >
                        {{ setNumbers.extraNumber }}
                    </li>
                </ul>
            </template>

            <template v-if="setNumbers.kingsNumber">
                <span class="pp-draw-numbers__draw-title">Královské číslo</span>
                <div class="pp-draw-numbers__crown-wrapper">
                    <PpDrawNumbersCrown class="pp-draw-numbers__crown" />
                    <span class="pp-draw-numbers__number">{{ setNumbers.kingsNumber }}</span>
                </div>
            </template>

            <div v-if="lottery == Lottery.kameny" class="pp-draw-numbers__combinations">
                <div class="pp-draw-numbers__combinations-column">
                    <span class="pp-draw-numbers__combinations-title">Číslo</span>
                    <span class="pp-draw-numbers__combinations-number">{{ setNumbers.sumNumber }}</span>
                </div>
                <DsDivider :is-vertical="true" />
                <div class="pp-draw-numbers__combinations-column">
                    <span class="pp-draw-numbers__combinations-title">Kombinace čísel</span>
                    <span
                        class="pp-draw-numbers__combinations-number"
                        v-html="getCombinations(setNumbers.combinations)"
                    ></span>
                </div>
            </div>
        </template>
        <template v-if="numbers.addonNumbers">
            <span class="pp-draw-numbers__draw-title">{{ addonName }}</span>
            <ul class="pp-draw-numbers__num-row" data-test="row-addon">
                <li class="pp-draw-numbers__number" v-for="(num, index) in numbers.addonNumbers" :key="index">
                    {{ num }}
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { DrawNumbers } from "@/lotteries/services/model/draw-numbers";
import PpDrawNumbersCrown from "./pp-draw-numbers-crown.vue";
import DsDivider from "@sazka/design-system/src/divider/ds-divider.vue";
import { KamenyUtils } from "@sazka/lotteries/js/utils/kameny-utils";

const props = defineProps<{
    lottery: Lottery;
    numbers: DrawNumbers;
    sortByDraw: boolean;
}>();

const addonName = LotteryParser.addonDisplayName(props.lottery);

const getDrawLabel = (setIndex, drumIndex) => {
    return LotteryParser.getDrawLabel(props.lottery, props.lottery === Lottery.sportka ? setIndex : drumIndex);
};

const getNumbers = (numbers: number[]) => {
    if (props.sortByDraw) {
        return numbers;
    }

    return numbers.toSorted((a, b) => a - b);
};

const getCombinations = (combinations: number[]): string => {
    if (combinations.length < 1) return "-";
    const mapped = KamenyUtils.mapKamenyNumbers(combinations);
    return mapped.figures.map((x) => x.text).join(", ");
};
</script>
